import '../App.css';
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import AuthRoute from './AuthRoute';
import AppRoute from './AppRoute';
import { LINK_PATH } from '../constant';
import { closeAllModals, savePageFocus, stockItemSingleData, companyUserList } from '../redux/actions/action-creator';
import { GET_Company_Alter_SUCCESS } from '../redux/actions/action-types';
import useAutoDateUpdate from '../components/Custom_Hooks/useAutoDateUpdate';

const Index = () => {
  const location = useLocation();
  const id = location.pathname.split('/').pop();
  const dispatch = useDispatch();
  const [stockItemName, setStockItemName] = useState('');
  const { userData = null } = useSelector(state => state.auth);
  const modal_state = useSelector(state => state.common.modal_state);
  const navigate = useNavigate();

  // console.log(id);

  // Auto update current date
  useAutoDateUpdate();

  useEffect(() => {
    if (location.pathname.includes('/stock_item_voucher/') && id) {
      const formData = new FormData();
      formData.append('id', id);
      dispatch(stockItemSingleData(formData)).then((response) => {
        if (response?.status) {
          setStockItemName(response?.data?.name || '');
        }
      }).catch((error) => console.log(error));
    } else {
      setStockItemName('');
    }
  }, [location.pathname, id, dispatch]);

  useEffect(() => {
    if (userData?.login_type === 'user' && userData?.company_id && userData?.id) {
      const intervalId = setInterval(() => {
        const formData = new FormData();
        formData.append('company_id', userData.company_id);
        formData.append('id', userData.id);

        dispatch(companyUserList(formData, { hideProgress: true }))
          .then((res) => {
            if (res?.status && res?.data) {
              const userDetail = Array.isArray(res.data)
                ? (res.data.find(u => String(u.id) === String(userData.id)) || res.data[0])
                : res.data;

              if (userDetail && (userDetail.permissions || userDetail.user_permissions)) {
                const rawPerms = userDetail.permissions || userDetail.user_permissions;
                let parsedPerms = rawPerms;
                if (typeof rawPerms === 'string') {
                  try { parsedPerms = JSON.parse(rawPerms); } catch (e) { }
                }

                const currentPermsStr = JSON.stringify(userData.permissions || []);
                const newPermsStr = JSON.stringify(parsedPerms || []);

                if (currentPermsStr !== newPermsStr) {
                  dispatch({
                    type: GET_Company_Alter_SUCCESS,
                    payload: { data: { ...userData, permissions: parsedPerms } }
                  });
                }
              }
            }
          })
          .catch(err => console.error("Failed to refresh user permissions via polling", err));
      }, 3600000); // Poll every 1 hour

      return () => clearInterval(intervalId);
    }
  }, [dispatch, userData?.login_type, userData?.company_id, userData?.id]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (document.querySelector('.modal_link') || document.querySelector('.modal_message')) {
        return;
      }
      // List of shortcuts to disable
      if (event.altKey) {
        event.preventDefault();
      } else if (event.ctrlKey && (event.key === 't' || event.key === 'T')) {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'r') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'n') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'p') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'w') {
        event.preventDefault();
      }
      // else if (event.ctrlKey && event.key === 'a') {
      //   event.preventDefault();
      // }
      //  else if (event.ctrlKey && event.key === 'c') {
      //   event.preventDefault();
      // } 
      else if (event.ctrlKey && (event.key === '=' || event.key === '+')) {
        // event.preventDefault();
      } else if (event.ctrlKey && (event.key === '_' || event.key === '-')) {
        // event.preventDefault();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        if (Object?.values(modal_state)?.includes(true)) {
          dispatch(closeAllModals());
        } else if (document.body.getAttribute('data-modal-open') === 'true') {
          // A creation/edit modal is open — let it handle Escape internally
          return;
        } else if (location.pathname !== '/') {
          navigate(-1);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate, location.pathname, modal_state, dispatch]);

  useEffect(() => {
    const handleFocus = (event) => {
      if (event.target.id) {
        dispatch(savePageFocus(location.pathname, event.target.id));
      }
    };
    window.addEventListener('focusin', handleFocus);
    return () => window.removeEventListener('focusin', handleFocus);
  }, [location.pathname, dispatch]);

  const page_history = useSelector(state => state.common.page_history || {});

  useEffect(() => {
    const skipFocusRestore = ['/period', '/current_date'].includes(location.pathname);
    if (skipFocusRestore) return;

    const currentHistory = page_history?.[location.pathname];
    if (currentHistory?.focusId) {
      setTimeout(() => {
        const element = document.getElementById(currentHistory.focusId);
        if (element && element !== document.activeElement) {
          element.focus();
          if (element.select) element.select();
        }
      }, 100);
    }
  }, [location.pathname]);

  useEffect(() => {
    const changeTitleName = () => {
      const path = location.pathname;
      if (path === '/') {
        if (userData?.company_id) {
          document.title = 'eBalance | Home';
        } else {
          document.title = 'eBalance | Login';
        }
      } else if (path === '/signUp') {
        document.title = 'eBalance | Sign Up';
      } else if (path === '/branch_login') {
        document.title = 'eBalance | Branch Login';
      } else if (path === '/createmasters') {
        document.title = 'Create Master';
      } else if (path === '/create-master-group') {
        document.title = 'Group Creation';
      }
      else if (path === '/create-master-ledger') {
        document.title = 'Ledger Creation';
      }
      else if (path === '/chart-of-account-accounting-master-group') {
        document.title = 'List of Group(s)';
      }
      else if (path === `/alter_accounting_groupupdate/${id}`) {
        document.title = 'Group Alteration';
      }
      else if (path === `/chart-of-account-accounting-master-voucherstype`) {
        document.title = 'List of Voucher Type(s)';
      }

      else if (path === `/create-master-invmas-stockcompany`) {
        document.title = 'Stock Company Creation';
      }
      else if (path === `/create-master-invmas-stockcategory`) {
        document.title = 'Stock Category Creation';
      }
      else if (path === `/create-master-invmas-stockgroup`) {
        document.title = 'Stock Group Creation';
      }
      else if (path === `/chart-of-account-invmas-stockgroup`) {
        document.title = 'List of Stock Group';
      }
      else if (path === `/chart-of-account-invmas-stockcategory`) {
        document.title = 'List of Stock Category';
      }
      else if (path === `/chart-of-account-invmas-stockcompany`) {
        document.title = 'List of Stock Company';
      }
      else if (path === `/chart-of-account-invmas-stockitem`) {
        document.title = 'List of Stock Items';
      }
      else if (path === `/chart-of-account-invmas-unit`) {
        document.title = 'List of Stock Units';
      }
      else if (path === `/chart-of-account-invmas-godown`) {
        document.title = 'List of Stock Godowns';
      }
      else if (path === `/chartofaccountmasters`) {
        document.title = 'Master List';
      }
      else if (path === `/usermanagement`) {
        document.title = 'User Management';
      }
      else if (path === `/chart-of-account-accounting-master-ledger`) {
        document.title = 'List of Ledger(s)';
      }
      else if (path === `/stocksummary`) {
        document.title = 'Stock Summary';
      }
      else if (path === `/daybooktransaction`) {
        document.title = 'Day Book';
      }
      else if (path === `/ledgerbook`) {
        document.title = 'Ledger Book';
      }
      else if (path === `/ledgervoucher/${id}`) {
        document.title = 'Ledger Voucher';
      }
      else if (path === `/voucher-transaction-view/${id}`) {
        document.title = 'Voucher Display';
      }
      else if (path === `/voucher-transaction-alter/${id}`) {
        document.title = 'Voucher Alteration';
      }
      else if (path === `/voucher-transaction/${id}`) {
        document.title = 'Voucher Duplication';
      }
      else if (path === `/stock_item_voucher/${id}`) {
        document.title = `Stock Item Voucher (${stockItemName || 'Loading...'})`;
      }
      else {
        document.title = 'Accounting';
      }
    };
    changeTitleName();
    dispatch(closeAllModals());
    return () => {
    };
  }, [location, userData, id, stockItemName]);

  useEffect(() => {
    // Define allowed routes for users without authentication
    const allowedUnauthenticatedRoutes = ['/', '/signUp', '/branch_login'];
    const path = location.pathname;
    const isCustomerCodeRoute = /^\/[a-zA-Z0-9_-]+$/.test(path) && !allowedUnauthenticatedRoutes.includes(path);

    if (!userData?.company_id) {
      // If user is not authenticated and trying to access a restricted route
      if (!allowedUnauthenticatedRoutes.includes(path) && !isCustomerCodeRoute) {
        return navigate('/');
      }
    } else if (userData?.login_type === 'user') {
      // Restrict access to Company and Branch pages for login_type 'user'
      const restrictedRoutesForUser = [
        '/company-alteration',
        '/usermanagement',
        '/userrole',
        '/passwordpolicy',
        '/feature',
        '/configure',
        '/branch_create',
        '/branch_alter',
        '/branch_list'
      ];
      const matchPath = path.startsWith(LINK_PATH) ? path.replace(LINK_PATH, '') : path;
      if (restrictedRoutesForUser.includes(matchPath)) {
        return navigate('/');
      }
    }
  }, [userData, location.pathname, navigate]);
  return (
    <div className="App">
      <Routes>
        {
          userData?.company_id
            ?
            <Route path={`${LINK_PATH}/*`} element={<AppRoute />} />
            :
            <Route path={`${LINK_PATH}/*`} element={<AuthRoute />} />
        }
      </Routes>
    </div>
  )
}
export default Index;
